<!-- 运动统计报表页面 -->
<template>
  <div class="fuzzy-matching-box">
    <div class="fuzzy-matching-top">
      <!-- <el-row class="top-first-line">
        <el-col :span="5">
            <el-form-item label="IMEI：">
              <el-input v-model="Dform.titleValue" placeholder=''></el-input>
            </el-form-item>
        </el-col >
        <el-col :span="5">
            <el-form-item label="名称：">
              <el-input v-model="Dform.schoolValue" placeholder=''></el-input>
            </el-form-item>
        </el-col >
        <el-col :span="5">
        </el-col >
        <el-col :span="5">
        </el-col >
  
      </el-row> -->
      <!-- <h1 class="titleStyle">运动统计报表</h1> -->
      <el-row class="top-first-line the-second-line">
        <el-col :span="5">
            <el-form-item label="IMEI：">
              <el-input v-model="Dform.titleValue" placeholder=''></el-input>
            </el-form-item>
        </el-col >
        <el-col :span="5">
            <el-form-item label="名称：">
              <el-input v-model="Dform.schoolValue" placeholder=''></el-input>
            </el-form-item>
        </el-col >
          <el-col :span="5">
            <el-form-item label="开始时间：">
              <el-date-picker
                  v-model="Dform.startTime"
                  type="datetime"
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
        </el-col >
          <el-col :span="5">
            <el-form-item label="结束时间：">
              <el-date-picker
                  v-model="Dform.terminalTime"
                  type="datetime"
                  format="YYYY-MM-DD HH:mm:ss"
                  value-format="YYYY-MM-DD HH:mm:ss"
                  placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col >
        
        <el-button type="primary" class="query-button" @click="inquiryClick">查询</el-button>
      </el-row>
    </div>

    <div class="fuzzy-matching-bottom">
      <el-row class="list">
         <el-table
          stripe
         :border="true"
         class="table-Style"
         v-loading="loading"
         :header-cell-style="{background:'#EDF6FF',color:'#000',}"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column
            prop="imei"
            label="IMEI"
            >
          </el-table-column>
          <el-table-column
            prop="name"
            label="名称"
            >
          </el-table-column>
          <el-table-column
          label='所属单位'
          >
          <template #default="scope">
              <span v-if="scope.row.alias != null">{{scope.row.alias}}</span>
              <span v-else>{{scope.row.userName}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="countTime"
            label="统计时间"
            >
          </el-table-column >
          <el-table-column
            prop="stepNo"
            label="步数"
            >
          </el-table-column>
          <el-table-column
            prop="kiloMetres"
            label="公里数"
            >
          </el-table-column>
         
        </el-table>
        <div class="block-fenye" >
          <el-pagination
              :small="small"
              :disabled="disabled"
              :background="background"
              layout="prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
        </div>
      </el-row>

    </div>

  </div>
</template>

<script>
import { exerciseStep } from '@/assets/api/api'

export default {
  components: {
  },
  data () {
    return {
      loading:true,
      Dform: {
          titleValue: '',
          schoolValue: '',
          startTime : '',
          terminalTime: '',
      },
      matchTime: [],
      tableData: [],
      multipleSelection: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      total: 0
    }
  },
  created() {
    this.exerciseStepClick()
  },
  methods: {
    inquiryClick( ) {
      this.pageInfo.page = 1
      this.total = 0
      this.exerciseStepClick()
    },
    exerciseStepClick () {
      let params = {
        imei:this.Dform.titleValue,
        name:this.Dform.schoolValue,
        endTime: this.Dform.terminalTime,
        startTime: this.Dform.startTime,
        page: this.pageInfo.page,
        pageSize: this.pageInfo.pageSize,
        userId: JSON.parse(localStorage.getItem('user')).id,
      }
      exerciseStep(params).then((res)=> {
        this.tableData = res.data.list
        this.total = res.data.total
        console.log(this.tableData,res,'运动计步报表接口');
        this.loading = false
      }).catch((err)=> {
          console.log(err);
      })
    },
    handleSizeChange (val) {
      console.log(`${val} items pr page`)
    },
    handleCurrentChange (val) {
      this.pageInfo.page = val
      this.exerciseStepClick()

    },
  },
  filters: {
    // hanzi (val) {
    // if( val(/^[\u4E00-\u9FA5]{1,}$/) ){
    //   return alert('汉字');
    //   }else{
    //   return alert('其他');
    //   } 
    //}
  }
}
</script>

<style lang='scss' scoped>
.fuzzy-matching-box {

  width: 100%;
  height:  95%;
  .fuzzy-matching-top {
    height: 100px ;
    background-color: #fff;
    border-radius: 15px;
    display: flex;
    align-content: space-around;  
    align-items: center;
    .titleStyle{
          margin-left: 40px;
          font-size: 20px;
          font-weight: 700;
          width: 35%;
    }
    
      :deep() {
        .el-input--small .el-input__wrapper{
              margin-right: 15px;
              border-radius: 15px
              ;
            }
        .el-select--small {
            width: 100%
        }
        .el-form-item--small .el-form-item__label {
          width: 110px;
          text-align: right;
          height: 35px;
          line-height: 35px;     
          font-weight: 700;     
          font-size: 16px;
        }
        .el-form-item {
            width: 109%;
            margin-left: 15px;
          }
        .el-input {
          width: 100%;
          height: 35px;
        }
    }
    .the-second-line {
      margin-top: 15px;
      position: relative;
      .query-button {
        position: absolute;
        right: 35px;
        padding: 16px 24px;
        // top: 50%;
        // transform: translate(0,-50%);
        // background-color:#1BC896;;
        border-radius: 15px;
      }
    }
    :deep() {
      .el-range-editor--small.el-input__wrapper {
          height: 35px;
          line-height: 35px;  
      }
 
    }
  }
  .fuzzy-matching-bottom {
    height:85%;
    overflow: auto;
    position: relative;
    padding: 0px 20px;
    padding-top: 30px;
    margin-top: 15px;
    background-color: #fff;
    border-radius: 15px;
    .table-Style{
      font-size: 16px;
      // border-radius: 15px;
    }
    
      .top-first-line {
      height: 45px;
      line-height: 45px;
        :deep(.tip-button) {
          padding: 14px 14px;
          margin: 0px 3px;
        }
      .import-export-button {
        position: absolute;
        right: 20px;
        :deep(.el-button--small) {
          padding: 16px 24px;
          border: 1px solid #569CFF;
          color: #569CFF;
        }
      }
    }
    .list {
      position: relative;
      // margin-top: 10px;
      padding-bottom: 50px;
     .fenye {
      // float: right;
      text-align: center;
     }
      :deep() {
       
        .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
          // border: 0px;
        }
        .el-table tr {
          height: 40px;
          cursor: pointer;
          font-size: 14px;
          user-select: initial;
          font-size: 16px;
          color: black;


        }
         .manipulate {
          color: red;
          margin-right:15px;
          cursor: pointer;
          user-select: none;
        }
        .confirm,.duplicate,.revise {
          color:#1677FF;
          
        }
        .el-table th.el-table__cell>.cell {
          text-align: center;
          font-weight: 700;
        }
        .el-table td.el-table__cell, .fuzzy-matching-box .fuzzy-matching-bottom .list[data-v-1ddf37d1] .el-table th.el-table__cell.is-leaf {
          text-align: center;
        }
      }
      .block-fenye {
        // float: right;
        position: absolute;
        bottom: 0px;
        left: 50%;
        transform: translate(-50%,0);
        
      }
    }
  }
  
}
</style>
